import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./overlay.css?inline";

@customElement("eko-overlay")
export class Overlay extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private handleClick = (event: Event) => {
    if (event.target === this) {
      this.dispatchEvent(new Event("close"));
    }
  };

  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener("mousedown", this.handleClick);
    this.addEventListener("touchstart", this.handleClick);
  }

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-overlay": Overlay;
  }
}

export default Overlay;
